module.exports = __webpack_public_path__ + "img/Servca-symbol.v1.3--dark.c7a48d0.svg";